import { message } from 'antd';
import { useState } from 'react';
import useShopeeAuthShops from './useShopeeAuthShops';
import { useTranslate } from '@tolgee/react';

const useShopeeSmsCaptcha = () => {
  const { t } = useTranslate();

  const [smsInputValue, setSmsInputValue] = useState('');

  const { continueSmsCaptcha } = useShopeeAuthShops();

  // @ts-ignore
  const onChange = (e) => {
    const { value } = e.target;
    const reg = /^-?\d*(\.\d*)?$/;
    if ((!Number.isNaN(value) && reg.test(value)) || value === '' || value === '-') {
      setSmsInputValue(value);
    }
  };

  const submitSms = () => {
    if (smsInputValue.length !== 6) {
      message.error(t('errorMsg.请输入 6 位验证码'));
      return;
    }
    continueSmsCaptcha(smsInputValue);
    setSmsInputValue('');
  };

  return {
    smsInputValue,
    setSmsInputValue,
    submitSms,
    onChange,
  };
};

export default useShopeeSmsCaptcha;
